module.exports = __webpack_public_path__ + "static/media/share_success.8201420e.gif";